// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-wrap[data-v-4e9f7348]{overflow:hidden;text-overflow:ellipsis;word-break:break-all;white-space:normal;display:-webkit-box;-webkit-box-orient:vertical}.content-div[data-v-4e9f7348]{max-width:500px;overflow:auto;padding:5px 11px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
